var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.isShowTitle)?_c('span',{staticClass:"text-16-bold mb-16",staticStyle:{"display":"inline-block"}},[_vm._v(_vm._s(_vm.editData.title))]):_vm._e(),_c('div',{staticClass:"multEdit text-14-primary",domProps:{"innerHTML":_vm._s(_vm.editData.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }